<template>
  <node-view-wrapper class="mail-tag-wrapper">
    <span 
      class="mail-tag"
      :class="{ 'invalid-mail': !node.attrs.valid }"
      contenteditable="false"
      @click.stop
    >
      <a-tooltip v-if="!node.attrs.valid" title="Geçersiz e-posta formatı">
        <span class="mail-content">{{ node.attrs.mail }}</span>
      </a-tooltip>
      <span v-else class="mail-content">{{ node.attrs.mail }}</span>
      <span class="remove-tag" @click="deleteNode"><i class="material-icons">close</i></span>
    </span>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper } from '@tiptap/vue-2'

export default {
  name: 'MailTagComponent',
  components: {
    NodeViewWrapper,
  },
  props: {
    editor: {
      type: Object,
      required: true,
    },
    node: {
      type: Object,
      required: true,
    },
    updateAttributes: {
      type: Function,
      required: true,
    },
    deleteNode: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.mail-tag-wrapper {
  display: inline-block;
  margin: 2px 4px 2px 0;
  vertical-align: middle;
}

.mail-tag {
  display: inline-flex;
  align-items: center;
  background-color: #f0f0f0;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 2px 8px;
  white-space: nowrap;
  vertical-align: middle;
  
  &.invalid-mail {
    border-color: #ff4d4f;
    background-color: rgba(255, 77, 79, 0.1);
  }
  
  .mail-content {
    font-size: 14px;
    color: #22272d;
  }
  
  .remove-tag {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
    
    i {
      font-size: 16px;
      color: #999;
      
      &:hover {
        color: #ff4d4f;
      }
    }
  }
}
</style> 